/* eslint-disable */
import { userActionTypes } from "../actions/actionTypes";

const initialState = {
  users: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case userActionTypes.SET_ALL_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case userActionTypes.UPDATE_SINGLE_USER:
      const updatedUsers = state.users.map((user) => {
        if (user.email === action.payload.email) {
          return { ...user, ...action.payload };
        }
        return user;
      });
      return {
        ...state,
        users: updatedUsers,
      };
    default:
      return state;
  }
};

export default userReducer;
